export const LAND_CAPABILITY_SOURCES = [
  {
    id: 'alc-provisional-england',
    region: 'england',
    kind: 'wms',
    wmsBase:
      'https://environment.data.gov.uk/geoservices/datasets/af1b847b-037b-4772-9c31-7edf584522aa/wms',
    layerName: 'Agricultural_Land_Classification_Provisional_England',
    scaleNote: '1:250k',
    minZoom: 11,
    licenceStatus: 'verified',
    precedence: 100,
  },
  {
    id: 'alc2-predictive-wales',
    region: 'wales',
    kind: 'wms',
    wmsBase: 'https://datamap.gov.wales/geoserver/inspire-wg/wms',
    layerName: 'inspire-wg:wg_predictive_alc2',
    scaleNote: '1:250k',
    minZoom: 8,
    licenceStatus: 'verified',
    unverified: false,
    precedence: 100,
  },
  {
    // ONE SOURCE, REPLACING THE 1:250k AND 1:50k PAIR. Changed 18/08/2026, when
    // both of the old druid.hutton.ac.uk services went with Hutton's host-wide
    // ArcGIS Server outage (see the note in soil.js for the diagnosis).
    //
    // Hutton's ArcGIS Online replacement is a "Hybrid" cache that already does
    // the compositing the two toggles used to do by stacking: 39,313 features
    // surveyed at 1:50k laid over 5,101 at 1:250k, so the fine detail shows
    // wherever it was surveyed and the coarse map fills the rest. Two toggles
    // pointing at it would draw identical tiles, with the 1:250k one showing
    // 1:50k detail, which reads as a bug. Davin's call: one entry, both scales.
    //
    // WHICH CACHE, and why not the obvious one. Hutton publish two Web Mercator
    // caches of this data. `Hutton_LCA_Hybrid_WebMerc` renders in the palette
    // our legend already carries, verified pixel for pixel, and reaches z15 —
    // but it has repeating "50K" and "250K" scale labels drawn into the tiles,
    // which cannot be switched off and which land on top of the farmer's field.
    // This one has no labels. Davin picked it on 18/08 after seeing both, and
    // the cost is that its palette is completely different, so the legend
    // swatches were updated to match (see data/legend-metadata.js).
    //
    // Not the `..._Tile` variant of this same service: identical output, but it
    // is only built to z12 where this one reaches z13.
    id: 'hutton-lca-scotland',
    region: 'scotland',
    kind: 'arcgis-tiles',
    serviceUrl:
      'https://tiles.arcgis.com/tiles/GUWZHTCSOJuIKNzF/arcgis/rest/services/Land_Capability_for_Agriculture/MapServer',
    scaleNote: '1:50k where surveyed, else 1:250k',
    // The 1:250k half started at zoom 8, so the merged layer keeps that floor
    // rather than the 1:50k layer's 10: there is coarse data to show at 8.
    minZoom: 8,
    // Advertises LODs to 23, actually built to 13. Measured, not read off the
    // service description, which is wrong for both Scottish caches.
    maxCachedZoom: 13,
    licenceStatus: 'verified',
    unverified: false,
    precedence: 100,
  },
];
